import React from 'react';
import Chart, { Props as ApexProps } from 'react-apexcharts';

import { ChartWrapper } from '../../../components/Charts/ChartWrapper';
import { useAppSelector } from '../../../../../store';
import { useGetSemanticsQuery } from '../service/messages.api';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const MessageTopicsChart = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const {
        data: semantic = {},
        isFetching,
        isLoading,
    } = useGetSemanticsQuery(
        {
            ...filters,
            community_id: filters.chat,
        },
        { refetchOnMountOrArgChange: true }
    );

    const series = Object.entries(semantic)
        .sort((a, b) => (a[1] > b[1] ? 1 : b[1] > a[1] ? -1 : 0))
        .reverse()
        .slice(0, 4);

    const options: ApexProps['options'] = {
        labels: [...series.map(s => s[0])],

        legend: {
            show: true,
            position: 'left',
        },
        plotOptions: {
            pie: {
                expandOnClick: false,
            },
        },
        theme: {
            monochrome: {
                enabled: true,
                color: '#597EF7',
            },
        },
    };

    return (
        <ChartWrapper
            isLoading={isFetching || isLoading}
            title='Темы сообщений'
        >
            <Chart
                type='pie'
                height={'100%'}
                options={options}
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                series={[...series.map(s => s[1])]}
            />
        </ChartWrapper>
    );
};
